<template lang="pug">
    v-form(ref="virtualAccountForm" id="virtualAccountForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg3 md3 xs12 v-if="isUpdate")
                    v-text-field(dense v-model="virtualAccount.virtualAccountNumber" :rules="[v => !!v || 'Input No Virtual Account']"
                        label="No. Virtual Account" required readonly)
                v-flex(lg6 md6 xs12)
                    v-text-field(dense v-model="virtualAccount.virtualAccountName" :rules="[v => !!v || 'Input Nama Virtual Account']"
                        label="Nama Virtual Account" required)
                v-flex(lg2 md2 xs12 v-if="virtualAccount.virtualAccountFixed")
                    v-text-field(dense v-model="virtualAccount.idMember" :rules="[v => !!v || 'Input ID Member']" 
                        label="ID Member" :readonly="isUpdate" required)
            v-layout(wrap v-if="virtualAccount.virtualAccountType == 'CR_ONLY' && !virtualAccount.virtualAccountInvoice && !virtualAccount.virtualAccountInstallment")
                v-flex(lg3 md3 xs12)
                    f-radio-virtual-account-fixed(v-model="virtualAccountFixed" :readonly="isUpdate")
                v-flex(lg3 md3 xs12)
                    f-radio-virtual-account-open(v-model="virtualAccount.virtualAccountOpen" :readonly="isUpdate || readOnly")
                v-flex(lg3 md3 xs12)
                    f-radio-virtual-account-single(v-model="virtualAccount.virtualAccountSingle" :readonly="isUpdate || readOnly")
            v-layout(wrap v-if="virtualAccount.virtualAccountType != 'CR_ONLY'" )
                v-flex(lg12 md12 xs12)
                    f-radio-virtual-account-type(v-model="virtualAccount.virtualAccountType" :readonly="isUpdate")
            v-layout(wrap v-if="virtualAccount.virtualAccountInvoice" )
                v-flex(lg9 md9 xs12)
                    v-text-field(dense v-model="virtualAccount.invoiceMessage" :rules="[v => !!v || 'Input Keterangan Invoice']"
                        label="Keterangan Invoice" required :readonly="isUpdate")
            v-layout(wrap v-if="virtualAccount.virtualAccountInstallment" )
                v-flex(lg9 md9 xs12)
                    v-text-field(dense v-model="virtualAccount.installmentMessage" :rules="[v => !!v || 'Input Keterangan Installment']"
                        label="Keterangan Installment" required :readonly="isUpdate")
                    v-flex(lg12 md12 xs12)
                        div(class="caption font-weight-bold primary--text") Jenis Installment
                            v-radio-group(dense v-model="virtualAccount.installmentType" row) 
                                v-radio(label="Nominal Cicilan Tidak Ditentukan" value="OPEN" color="primary")
                                v-radio(label="Nominal Cicilan Ditentukan" value="CLOSED" color="primary")
            v-layout(wrap)
                v-flex(lg2 md2 xs12 v-if="virtualAccount.installmentMessage")
                    v-text-field(dense v-model="virtualAccount.tenor" label="Tenor" maxlength="3" v-numeric-only :readonly="isUpdate")
                v-flex(lg2 md2 xs12)
                    f-date-box(v-model="dateExpired" label="Masa Berlaku")
                v-flex(lg2 md2 xs12)
                    f-timebox(dense v-model="timeExpired")
            v-layout(wrap)
                v-flex(lg3 md3 xs12 v-if="virtualAccount.virtualAccountOpen || (virtualAccount.installmentType && virtualAccount.installmentType == 'OPEN')")
                    f-decimalbox(v-model="virtualAccount.minTransaction" label="Minimal Transaksi" :readonly="isUpdate")
                v-flex(lg3 md3 xs12 v-if="virtualAccount.virtualAccountOpen || (virtualAccount.installmentType && virtualAccount.installmentType == 'OPEN')")
                    f-decimalbox(v-model="virtualAccount.maxTransaction" label="Maksimal Transaksi")
                v-flex(lg3 md3 xs12 v-if="!virtualAccount.virtualAccountOpen || virtualAccount.virtualAccountInvoice || virtualAccount.virtualAccountInstallment")
                    f-decimalbox(v-model="virtualAccount.amount" label="Nominal" :rules="[v => !!v || 'Masukan nominal transaksi', v => (virtualAccount.amount || 0) > 0 || 'Nominal tidak valid' ]" :readonly="isUpdate")
            v-layout(wrap) 
                v-flex(lg12 md12 xs12 class="primary--text title-text") Data Tambahan
                    v-stepper(v-model="step")
                        v-stepper-items
                            v-stepper-content(step="1")
                                v-data-table(
                                    hide-default-footer
                                    :headers="headers" 
                                    :loading="loading"
                                    loading-text="Proses mengambil data ....."
                                    no-data-text="Data tidak ditemukan ....."
                                    no-results-text="Data tidak ditemukan ....."
                                    :items="listData"
                                    :page.sync="page"
                                    :items-per-page="itemsPerPage"
                                    @page-count="pageCount = $event"
                                    :search="criteria"
                                )    
                                    template(v-slot:top)
                                        v-container(grid-list-md)
                                            v-layout(wrap menu-btn)
                                                v-flex(lg2 md2 xs12)
                                                    v-btn(color="info" @click="form(false)") Tambahkan Data
                                                v-spacer
                                                v-flex(lg5 md5 xs12)
                                                    v-text-field(dense v-model="criteria" label="Filter Data Pencarian" prepend-icon="mdi-magnify" clearable)
                                    template(v-slot:item.action="{item}")
                                        v-layout(wrap justify-center menu-btn-sm my-1)
                                            f-button-option(:update="true" :del="true" v-on:update="form(true, item)" v-on:delete="doRemoveAdditional(item)")
                                div(class="text-xs-center ma-2")
                                    v-pagination(v-model="page" :length="pageCount")
                            v-stepper-content(step="2")
                                f-additional-data-form(:isUpdate="isUpdateAdd" :additional="item" v-on:cancel="step = '1'" v-on:save="doAddAdditional" v-on:update="doUpdateAdditional")
            div(justify-center style="text-align: center" class="ma-2 menu-btn" v-if="step != '2'")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="virtualAccountForm") Simpan
                    v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FVirtualAccountForm",
    props: ["isUpdate", "va"],
    data() {
        return {
            virtualAccount: {
                virtualAccountNumber: null,
                virtualAccountName: "",
                idMember: null,
                amount: 0,
                minTransaction: 0,
                maxTransaction: 0,
                virtualAccountFixed: true,
                virtualAccountOpen: true,
                virtualAccountSingle: false,
                virtualAccountType: "DBCR"
            },
            readOnly: false,
            dateExpired: null,
            timeExpired: null,
            step: "1",
            listData: [],
            loading: false,
            criteria: "",
            headers: [
                {text: 'KEY', value: 'key', sortable: false, width: "150px", class: "primary--text"},
                {text: 'VALUE', value: 'value', sortable: false, class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "110px", align:"center", class: "success--text"},
            ],
            page: 1,
            itemsPerPage: 5,
            pageCount: 0,
            item: {},
            isUpdateAdd: false
        }
    },
    watch: {
        va(val){
            this.doInit(val);
        },
        virtualAccountFixed(val){
            this.virtualAccount.virtualAccountFixed = val;
            if (val) {
                this.readOnly = false;
            }else{
                this.virtualAccount.virtualAccountOpen = false;
                this.virtualAccount.virtualAccountSingle = true;
                
                this.readOnly = true;
            }
        },
    },
    mounted() {
        this.doInit(this.va);
    },
    methods: {
        doInit(values){
            if (this.$refs.virtualAccountForm) {
                this.$refs.virtualAccountForm.resetValidation();
            }
            this.virtualAccount = values ? values : {
                virtualAccountNumber: null,
                virtualAccountName: "",
                idMember: null,
                amount: 0,
                minTransaction: 0,
                maxTransaction: 0,
                virtualAccountFixed: true,
                virtualAccountOpen: true,
                virtualAccountSingle: false,
                virtualAccountType: "DBCR"
            };
            this.dateExpired = this.virtualAccount.virtualAccountExpired ? this.$options.filters.localdate(this.virtualAccount.virtualAccountExpired) : null;
            this.timeExpired = this.virtualAccount.virtualAccountExpired ? this.$options.filters.timeformat(this.virtualAccount.virtualAccountExpired) : null;
            this.mapToList(this.virtualAccount.additionalData);
        },
        doSave(){
            if (this.$refs.virtualAccountForm.validate()) {
                this.$refs.virtualAccountForm.resetValidation();
                let date = null;
                if (this.dateExpired != null) {
                    if (this.timeExpired != null) {
                        date = this.dateExpired + " " + this.timeExpired;
                    } else {
                        date = this.dateExpired + " 00:00:00";
                    }
                }
                this.virtualAccount.virtualAccountExpired = date ? this.$options.filters.localdatetime(date) : date;
                this.virtualAccount.installmentExpired = this.virtualAccount.virtualAccountExpired;
                this.virtualAccount.invoiceExpired = this.virtualAccount.virtualAccountExpired;
                if (this.listData.length > 0) {
                    this.virtualAccount.additionalData = this.listToMap();
                } else {
                    this.virtualAccount.additionalData = {};
                }
                this.$emit("va", this.virtualAccount);
            }
        },
        doCancel(){
            this.$refs.virtualAccountForm.resetValidation();
            this.$emit("cancel");
        },
        mapToList(additional){
            this.listData = [];
            if(additional){
                for (const [key, value] of Object.entries(additional)) {
                    this.listData.push({
                        "key": key,
                        "value": value
                    })
                }
            }
        },
        listToMap(){
            return Object.assign({}, ...this.listData.map(s => ({[s.key]: s.value})));
        },
        form(update, item) {
            this.isUpdateAdd = update;
            this.item = item ? item : {};
            this.step = "2";
        },
        doAddAdditional(item){
            this.listData.push(item);
            this.step = "1";
        },
        doUpdateAdditional(item){
            const obj = this.listData.indexOf(this.item);
            if (obj !== undefined) {
                this.listData.splice(obj, 1, item);
            }
            this.step = "1";
        },
        doRemoveAdditional(item){
            const obj = this.listData.indexOf(item);
            if (obj !== undefined) {
                this.listData.splice(obj, 1);
            }
            this.step = "1";
        },
    },
}
</script>